import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { DataExchangeSaveToDirectoryService } from 'src/app/services/data-exchange-save-to-directory.service';

@Component({
  selector: 'app-save-to-directory-button',
  templateUrl: './save-to-directory-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SaveToDirectoryButtonComponent {
  private readonly saveToDirectoryService = inject(DataExchangeSaveToDirectoryService);

  readonly subRequestId = input.required<number>();

  saveToDirectory(): void {
    this.saveToDirectoryService.saveSubRequest(this.subRequestId()).subscribe();
  }
}
